import { render, staticRenderFns } from "./VerificationProfile.vue?vue&type=template&id=311c5185&scoped=true&"
import script from "./VerificationProfile.vue?vue&type=script&lang=ts&"
export * from "./VerificationProfile.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationProfile.vue?vue&type=style&index=0&id=311c5185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c5185",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VLayout,VRow})
